export const BZ_CONTACT_PHONE = '1 (877) 440-9464';
export const BZ_CONTACT_PHONE_HREF = 'tel:+18774409464';
export const BZ_CONTACT_EMAIL = 'verify@benzinga.com';
export const BZ_IFRAME_LOGIN_SITE = 'https://www.benzinga.com/login/?iframe=true&phone=required';
export const BZ_LOGIN_NEXT = 'https://pro.benzinga.com/dashboard';
export const BZ_REGISTER_NEXT = 'https://pro.benzinga.com/dashboard/upsell';
export const BZ_STRIPE_KEY = 'pk_live_jaMpv6EMQhvjzDbiITCMQnjB';
